<div class="container-fluid">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="col">
        <h3 style="margin-bottom: 0 !important;">
          <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'exclamation-triangle']"> </fa-icon> Supervision Alerts </span>
        </h3>
      </div>
      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right"
                           btnIcon="question-circle" btnType="warning"
                           (btnClicked)="openAlertsLoadingHelp()"></app-eca-ghost-btn>
      </div>
    </ng-template>
    <ng-template pTemplate="content" class="eca-card-body">
      <div class="container-fluid" style="margin-bottom: 50px; padding-right: 0; padding-left: 0;">
        <div *ngIf="alertsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen"
                           secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!alertsLoading">
          <div class="container-fluid" style="padding-left: 0; padding-right: 0;">
            <div class="row">
              <div class="col">
                <div *ngIf="loadingAlerts" class="text-center">
                  <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                                   primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                </div>
                <div *ngIf="!loadingAlerts">
                  <p-table [totalRecords]="supervisionAlerts?.length" #tt [value]="supervisionAlerts" [globalFilterFields]="columns" dataKey="id"
                           styleClass="p-datatable-striped p-datatable-responsive-eca"
                           [scrollable]="!isOnMobile && supervisionAlerts?.length > 5" scrollHeight="500px" [responsive]="true"
                           [columns]="columns">
                    <ng-container>
                      <ng-template pTemplate="caption">
                        <div class="row d-flex justify-content-between align-items-center">
                          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                            <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                              <div class="col-auto">
                                <h5 class="eca-primary-text h5-relative-font-size">
                                  <span *ngIf="alertInfos"> {{ alertInfos.length }}</span>
                                  Operative/s In High Supervision
                                </h5>
                              </div>
                            </div>
                          </div>
                          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                            <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                              <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-8">
                                      <span class="p-input-icon-left">
                                          <i class="pi pi-search"></i>
                                          <input pInputText type="text" class="form-control"
                                                 id="ctrlSearchInput" style="min-width: 150px"
                                                 placeholder="Search All"
                                                 (input)="tt.filterGlobal($event.target.value, 'contains')">
                                        </span>
                              </div>
                              <div class="col-auto">
                                <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"
                                                   (btnClicked)="exportToExcel()">
                                </app-eca-ghost-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 12%" pSortableColumn="operativeFullName">
                          Name
                          <p-sortIcon field="operativeFullName"></p-sortIcon>
                        </th>
                        <th style="width: 12%" pSortableColumn="referenceNumbers">
                          Reference Nos
                          <p-sortIcon field="referenceNumbers"></p-sortIcon>
                        </th>
                        <th style="width: 12%" pSortableColumn="currentJobTitle">
                          Job Role
                          <p-sortIcon field="currentJobTitle"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pSortableColumn="currentRisk">
                          Work Risk
                          <p-sortIcon field="currentRisk"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pSortableColumn="currentJobLevel">
                          Job Level
                          <p-sortIcon field="currentJobLevel"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pSortableColumn="riskMatrixLevel">
                          Supervision
                          <p-sortIcon field="riskMatrixLevel"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pSortableColumn="startedOn">
                          Started On
                          <p-sortIcon field="startedOn"></p-sortIcon>
                        </th>
                        <th style="width: 10%"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-operativeAlert let-columns="columns">
                      <tr>
                        <td *ngFor="let col of columns">
                          <span class="p-column-title">{{col.header}}: </span>
                          <label>
                            <span *ngIf="col.type=== 'text'">{{ operativeAlert[col.field] }}</span>
                            <span *ngIf="col.type === 'enum'">{{ DegreeOfSupervisionString[operativeAlert[col.field]] }}</span>
                            <span *ngIf="col.type === 'date'">{{ operativeAlert[col.field] | date:'dd/MM/yyyy' }}</span>
                          </label>
                        </td>
                        <td>
                          <div class="text-center">
                            <app-eca-row-menu (viewBtnClicked)="viewOperative(operativeAlert)"
                                              [rowMenuVisible]="false">
                            </app-eca-row-menu>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
